<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
<ziro-breadcrumbs></ziro-breadcrumbs>
@if (!isLoading) {
  <ziro-cluster-form
    [entity]="initialCluster"
    [serverOptions]="servers"
    [allClusters]="allClusters"
    (ziroFormsUpdate$)="onFormUpdate($event)"
  ></ziro-cluster-form>
}
